/**
 * Consistent Spacing System
 *
 * Provides uniform spacing scale across all components and layouts
 * Based on 4px base unit for pixel-perfect alignment
 */

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  '2xl': 48,
  '3xl': 64,
  '4xl': 96,
} as const;

// Component-specific spacing
export const componentSpacing = {
  // Card padding variants
  cardPadding: {
    sm: spacing.sm,     // 8px - Compact cards
    md: spacing.md,     // 16px - Standard cards
    lg: spacing.lg,     // 24px - Spacious cards
  },

  // Button padding
  buttonPadding: {
    horizontal: {
      sm: spacing.sm,   // 8px
      md: spacing.md,   // 16px
      lg: spacing.lg,   // 24px
    },
    vertical: {
      sm: spacing.xs,   // 4px
      md: spacing.sm,   // 8px
      lg: spacing.sm,   // 8px
    },
  },

  // Input padding
  inputPadding: {
    horizontal: spacing.md,  // 16px
    vertical: spacing.sm,    // 8px
  },

  // Section spacing
  sectionGap: spacing.lg,    // 24px between sections
  elementGap: spacing.md,    // 16px between elements
  itemGap: spacing.sm,       // 8px between list items
} as const;

export type Spacing = typeof spacing;
export type SpacingKey = keyof typeof spacing;

export default spacing;